import React, { MutableRefObject, RefObject } from 'react';

import { BryntumSchedulerPro } from '@bryntum/gantt-react';

import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { SchedulerControls } from 'components/common/bryntumScheduler/SchedulerControlsHook';
import { SchedulerView } from 'components/common/bryntumScheduler/SchedulerView';

import { UseViewsManagerProvider } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.provider';
import { NoConfigurationEmptyState } from 'components/pages/ScheduleViewsPage/components/NoConfigurationEmptyState/NoConfigurationEmptyState';
import { SchedulerViewWrapperLogic } from 'components/pages/ScheduleViewsPage/components/SchedulerViewWrapper/SchedulerViewWrapper.logic';
import { useScheduleViewIdUrlState } from 'components/pages/ScheduleViewsPage/hooks/useScheduleViewIdUrlState';

import classes from './SchedulerViewWrapper.module.scss';

interface Props {
    api: UseViewsManagerProvider['api'];
    setIsConfigureDrawerOpen: (isOpen: boolean) => void;
    schedulerInstanceRef: RefObject<BryntumSchedulerPro>;
    controlsRef: MutableRefObject<SchedulerControls>;
}

export const SchedulerViewWrapper = ({ api, setIsConfigureDrawerOpen, schedulerInstanceRef, controlsRef }: Props) => {
    const [viewId] = useScheduleViewIdUrlState();
    const { data: viewConfiguration, isFetching, isLoading } = api.getPoapViewById.instance({ viewId: Number(viewId) });
    const isNoConfiguration = viewConfiguration?.viewRows?.length === 0;

    const { logic } = SchedulerViewWrapperLogic({ data: viewConfiguration });

    if (isLoading || isFetching) {
        return (
            <div className={classes.SchedulerViewWrapper}>
                <OverlayWithSpinner />
            </div>
        );
    }
    if (isNoConfiguration) {
        return <NoConfigurationEmptyState setIsConfigureDrawerOpen={setIsConfigureDrawerOpen} />;
    }
    return (
        <div className={classes.SchedulerViewWrapper}>
            <ErrorBoundary fallback={'Error loading view configuration'}>
                {viewConfiguration && !isFetching && (
                    <SchedulerView
                        data={viewConfiguration}
                        schedulerInstanceRef={schedulerInstanceRef}
                        controlsRef={controlsRef}
                        headerTimelineLabels={logic.headerLabels ?? undefined}
                    />
                )}
            </ErrorBoundary>
        </div>
    );
};
